import { ApiError, transportProblem, type Problem } from "@baton/api";

/** The problem behind any rejection the transport produced; a foreign error is a transport failure. */
export function problemOf(error: unknown): Problem {
  return error instanceof ApiError ? error.problem : transportProblem(0, "");
}
